import TableBlock1 from '../common/blocks/TableBlock1';
const AddmissionPolicy = () => {
	return (
		<TableBlock1 />	
	);
};
export default AddmissionPolicy;